import { render, staticRenderFns } from "./listDialog.vue?vue&type=template&id=55acfbe1&scoped=true"
import script from "./listDialog.vue?vue&type=script&lang=js"
export * from "./listDialog.vue?vue&type=script&lang=js"
import style0 from "./listDialog.vue?vue&type=style&index=0&id=55acfbe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acfbe1",
  null
  
)

export default component.exports